module.exports = __webpack_public_path__ + "static/tech-Icon-pyramid-21ca51b5c6673302d6c0e6bd2c076e0f.png";